/* ExportAction.js */

"use strict";
const _ = require("lodash");

class ExportAction {
    constructor(logger, gameEditor, activeView, OsUpgradePlan, userSession, steveIo) {
        this._logger = logger;
        this._activeView = activeView;
        this._OsUpgradePlanDef = OsUpgradePlan;
        this._activeOrgId = userSession.activeOrganization.id;
        this._fileFactory = steveIo.fileFactory;
        this._gameEditor = gameEditor;
        this.run = this.run.bind(this);
    }

    async run() {
        let result = [];
        let entityIds = this._activeView.getSelectedPlanIds();

        if (!_.isEmpty(entityIds)) {
            let entities =
                entityIds &&
                ((this._activeView.pagingFeed &&
                    entityIds.selectedRows &&
                    (await this._activeView.pagingFeed.getOsPlanEntitiesById(entityIds.selectedRows))) ||
                    this._gameEditor.getOsPlanEntitiesById(entityIds));
            if (!_.isEmpty(entities)) {
                Object.keys(entities).forEach((id) => {
                    result.push(_.omit(entities[id].properties, "latestHaveIChanged"));
                });
            }
            this._fileFactory.saveJsonAsFile(JSON.stringify(result), "PlanExport-" + new Date().toISOString() + ".json");

            return Promise.resolve();
        }
        return Promise.resolve();
    }
}
module.exports = ExportAction;

ExportAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "gameEditor.activeView",
    "$teve.entities.OsUpgradePlan",
    "$teve.userSession",
    "$teve.io"
];

ExportAction.$displayDetails = {
    type: "Action",
    name: "ExportAction",
    icon: "configdrift.export_devices",
    shown: false,
    title: "Export OS Plans",
    order: 5
};
